<template>
    <CContainer>
        <CRow>
            <CCol col="12" class="d-flex  overflow-auto">
                <CreateBtn class="mfe-2" :to="{ name: 'coupons.create' }" v-if="$policy('coupon').create" />
                <FilterIt />
                <SortIt class="mr-auto" />
            </CCol>
        </CRow>
        <Table :storeId="storeId" v-if="$policy('coupon').create" />
        <Grid :storeId="storeId" v-else />
    </CContainer>
</template>

<script>
import { Table, Grid, FilterIt, SortIt } from './partials'
import { sorts } from './partials/fields'
import { mapActions } from 'vuex'

export default {
    name: 'All',

    components: {
        FilterIt,
        Table,
        Grid,
        SortIt
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.fetch({
                page: 1,
                store_id: vm.storeId,
                sorter: sorts[0]['value']
            })
        })
    },

    data() {
        return {
            localStoreId: null
        }
    },

    computed: {
        storeId: {
            get() {
                return this.localStoreId || this.$route.query.store_id || null
            },
            set(newVal) {
                this.localStoreId = newVal
            }
        }
    },

    watch: {
        storeId(newVal) {
            this.fetch({
                page: 1,
                store_id: newVal
            })
        }
    },

    methods: {
        ...mapActions('coupon', [
            'fetch'
        ]),
    }
}
</script>